import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Button, Link } from '@chakra-ui/react';
import { Empty } from '../../../context/Chakra/Icons';

const ListEmpty = ({ description, buttonProps = {} }) => {
  const { t } = useTranslation();
  const { link, text, onClick } = buttonProps;

  return (
    <div className="member-center__list-empty">
      <Empty />
      <p>{t('member_points.no_data')}</p>
      {description && <p>{description}</p>}
      {text && (
        <Button p="0px" variant="default" autoFocus={false} onClick={onClick}>
          {link ? (
            <Link
              href={link}
              sx={{
                display: 'block',
                width: '100%',
                lineHeight: '32px',
                height: '100%',
                color: 'inherit',
              }}
              _hover={{
                color: 'inherit',
              }}
            >
              {text}
            </Link>
          ) : (
            text
          )}
        </Button>
      )}
    </div>
  );
};

ListEmpty.propTypes = {
  description: PropTypes.string,
  buttonProps: PropTypes.shape({
    text: PropTypes.string,
    onClick: PropTypes.func,
    link: PropTypes.string,
  }),
};

export default ListEmpty;
